
import React, { useState, useContext, createContext, useLayoutEffect, useEffect, useMemo } from "react";

import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";

import "./styles.css";

import LoginComponent from "./Login/login";
import MenuComponent from "./Menu/menu";

import { Box } from "@mui/material";

import { AuthProvider, AuthContext } from "../contexts/auth";

import Home from "./Home/home";
import Loader from "./Loader/loader";

import Settings from "./Settings";
import Distribution from "./Distribuicao";
import Pedidos from "./Pedidos";
import DistributionR from "./Distribuicao/distributionR";
import Cadastros from "./Cadastros";
import ConsultasIndex from "./Consultas";
import Comercial from "./Comercial";
import GerenciarTabela from "./Comercial/gerenciarTabela";
import ImpressaoTabela from "./Comercial/impressaoTabela";
import { Toaster } from 'react-hot-toast'
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { ptBR as datagridptBR } from '@mui/x-data-grid';


import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import ptBR from 'dayjs/locale/pt-br';
import { ptBR as localePTBR } from '@mui/x-date-pickers/locales';
import ContabilIndex from "./Contabil";
import RotasRegioes from "./Frete/rotasRegioes";
import Transportadoras from "./Frete/transportadoras";

import { useNavigate, useLocation } from 'react-router-dom';
import { history } from "../helpers/history";
import InvokeLogin from "./InvokeLogin";
import ExternalView from "./Pedidos/Order/externalview";

export const mobileWidth = '768'

export const externalComponent = createContext()

const theme = createTheme(
  {
    palette: {
      primary: { main: '#1976d2' },
    },
  },
  datagridptBR,
);

export const useWindowSize = () => {
  const [size, setSize] = useState([0, 0]);

  useLayoutEffect(() => {
    function updateSize() {
      setSize([window.innerWidth, window.innerHeight]);
    }

    window.addEventListener('resize', updateSize);
    updateSize();

    return () => window.removeEventListener('resize', updateSize);
  }, []);

  return size;
}


const LoaderProvider = ({ children, width, isMobile }) => {
  
  const [loader, setLoader] = useState(false)
  
  return (
    <externalComponent.Provider value={{ setLoader, width, isMobile }}>
      <Loader external show={loader} />
      {children}
    </externalComponent.Provider>
  )

}


const PrivateRoute = ({ botmenu, permission, component, noAuth = false }) => {
  const [width] = useWindowSize();
  const { authenticated, loading } = useContext(AuthContext);
  history.navigate = useNavigate();
  history.location = useLocation();
  const isMobile = width <= mobileWidth

  if (loading) {
    return <Loader external show={true} />;

  }

  if (!authenticated && !noAuth) {

    const url = window.location.href;
    const myUrl = new URL(url);
    const hashValue = myUrl.searchParams.get('hash');

    if (hashValue) {
      localStorage.setItem('hash', hashValue);
    }
    return <Navigate to="/login" />;
  }

  return (
    <>
      <ThemeProvider theme={theme}>
        <InvokeLogin />
        <LoaderProvider width={width} isMobile={isMobile} >
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={ptBR}
            localeText={localePTBR.components.MuiLocalizationProvider.defaultProps.localeText}
          >
            <Box className="main-screen">
              <Box sx={{ flex: 9, overflow: 'hidden' }}>{component &&
                <Box className={'default_padding'}>
                  {width <= mobileWidth && <Box sx={{ height: '3rem' }}></Box>}
                  {component}
                </Box>
              }
              </Box>
              <>{botmenu && <MenuComponent />}</>
            </Box>
          </LocalizationProvider>
        </LoaderProvider>
      </ThemeProvider >
    </>

  );
};



const AppRoutes = () => {

  const [hash, setHash] = useState('')

  const getHash = () => {

    const url = window.location.href;
    const myUrl = new URL(url);
    const hashValue = myUrl.searchParams.get('hash');

    setHash(hashValue)
  }

  useEffect(() => {
    getHash()
  }, [])

  return (

    <Router basename='/sistema'>
      <Toaster position='bottom-center' />
      <AuthProvider>

        <Routes>
          <Route exact path="/" element={<Navigate to="/login" replace />} />
          <Route exact path="/login" element={<LoginComponent />} />
          <Route
            exact
            path="/home"
            element={
              <PrivateRoute botmenu permission={true} component={<Home />} />
            }
          />
          <Route
            exact
            path="/settings"
            element={
              <PrivateRoute
                botmenu
                permission={true}
                component={<Settings />}
              />
            }
          />
          <Route
            exact
            path="/distribuicao"
            element={
              <PrivateRoute
                botmenu
                permission={true}
                component={<Distribution />}
              />

            }
          />
          <Route
            exact
            path="/pedidos"
            element={
              <PrivateRoute
                botmenu
                permission={true}
                component={<Pedidos />}
              />

            }
          />

          <Route
            exact
            path="/pelevor"
            element={
              <PrivateRoute
                botmenu
                permission={true}
                component={<Home />}
              />

            }
          />

          <Route
            exact
            path="/"
            element={
              <PrivateRoute children={
                <Navigate to="/home" />
              } />

            }
          />

          <Route
            exact
            path="/distribuicao/r"
            element={
              <PrivateRoute
                botmenu
                permission={true}
                component={<DistributionR hash={hash} />}
              />

            }
          />

          <Route
            exact
            path="/cadastros"
            element={
              <PrivateRoute
                botmenu
                permission={
                  true
                }
                component={<Cadastros />}
              />

            }
          />

          <Route
            exact
            path="/consultas"
            element={
              <PrivateRoute
                botmenu
                permission={
                  true
                }
                component={<ConsultasIndex />}
              />

            }
          />

          <Route
            exact
            path="/configuracoes"
            element={
              <PrivateRoute
                botmenu
                permission={
                  true
                }
                component={<Settings />}
              />

            }
          />
          <Route
            exact
            path="/contabil"
            element={
              <PrivateRoute
                botmenu
                permission={
                  true
                }
                component={<ContabilIndex />}
              />

            }
          />

          <Route
            exact
            path="/comercial"
            element={
              <PrivateRoute
                botmenu
                permission={
                  true
                }
                component={<Comercial />}
              />

            }
          />

          <Route
            exact
            path="/gerenciartabela"
            element={
              <PrivateRoute
                botmenu
                permission={
                  true
                }
                component={<GerenciarTabela />}
              />

            }
          />

          <Route
            exact
            path="/impressaotabela"
            element={
              <PrivateRoute
                botmenu
                permission={
                  true
                }
                component={<ImpressaoTabela />}
              />

            }
          />

          <Route
            exact
            path="/rotas_regioes"
            element={
              <PrivateRoute
                botmenu
                permission={
                  true
                }
                component={<RotasRegioes />}
              />

            }
          />

          <Route
            exact
            path="/transportadoras"
            element={
              <PrivateRoute
                botmenu
                permission={
                  true
                }
                component={<Transportadoras />}
              />

            }
          />

          <Route
            exact
            path="/ver_pedido/:id"
            element={
              <PrivateRoute
                botmenu
                noAuth={true}
                permission={
                  true
                }
                component={<ExternalView />}
              />
            }
          />

        </Routes>
      </AuthProvider>
    </Router>
  );
};

export default AppRoutes;
